import { FC } from 'react';

import { LegendProps } from 'recharts';

import { useChart } from 'components/ui/chart';

import { HiddenItemsTooltip } from './HiddenItemsTooltip';
import { LegendItem } from './LegendItem';
import { useLegendItemsVisibility } from './use-legend-items-visibility.hook';

const DEFAULT_MAX_VISIBLE_ITEMS = 5;

type AnalyticsLegendWithMoreProps = LegendProps & {
  nameKey?: string;
  maxVisibleItems?: number;
};

export const AnalyticsLegendWithMore: FC<AnalyticsLegendWithMoreProps> = ({
  payload,
  nameKey,
  maxVisibleItems = DEFAULT_MAX_VISIBLE_ITEMS
}) => {
  const { config } = useChart();

  const { visibleItems, hiddenItems, shouldShowMore } =
    useLegendItemsVisibility(payload, nameKey, config, maxVisibleItems);

  if (!payload || payload.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center justify-center gap-4 flex-wrap max-w-[300px] mx-auto">
      {visibleItems.map((processedItem, index) => (
        <LegendItem key={index} itemData={processedItem.itemData} />
      ))}

      {shouldShowMore && <HiddenItemsTooltip hiddenItems={hiddenItems} />}
    </div>
  );
};
